import { getCLS, getFID, getLCP } from 'web-vitals';
import pushToDataLayer from './push-to-data-layer';
const buildAndPushWebVitals = () => {
  getCLS(reportHandler);
  getFID(reportHandler);
  getLCP(reportHandler);
};
const reportHandler = ({
  name,
  delta,
  id
}) => {
  const metrics = {
    event: 'web-vitals',
    event_category: 'Web Vitals',
    event_action: name,
    event_value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    event_label: id,
    nonInteraction: true
  };
  pushToDataLayer(metrics);
};
export default buildAndPushWebVitals;
//# sourceMappingURL=build-and-push-web-vitals.js.map